'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.republishMessage = republishMessage;

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _publishMessage = require('../../pubsub/actions/publishMessage');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

function republishMessage(message) {
  return function (dispatch, getState) {
    var threadId = (0, _getSelectedThreadId.getSelectedThreadId)(getState());
    var thread = (0, _getThreadByThreadId.getThreadByThreadId)(getState(), { threadId: threadId });
    var channel = (0, _threadGetters.getChannel)(thread);

    var unpublishedMessage = (0, _buildUnpublishedMessage.buildUnpublishedMessage)(message);
    dispatch((0, _publishMessage.publishMessage)({ channel: channel, message: unpublishedMessage, threadId: threadId }));
    dispatch((0, _trackInteraction.trackInteraction)('republish-message'));
  };
}